import { createAction, props } from '@ngrx/store';
import { AppInitStatus } from '../state/app-init.state';

export const setAppInitState = createAction(
	'[App-Init] Set App Init State',
	props<{ state: AppInitStatus }>(),
);
